<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
        ทดสอบค่าบริการ Local
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        จำลองพารามิเตอร์เพื่อคำนวณค่าจอด — ไม่สร้าง transaction จริง ใช้เครื่องคำนวณชุดเดียวกับระบบ
      </p>
    </div>
    <div class="flex items-center gap-3">
      <span *ngIf="siteState.selectedSite()?.name"
        class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-3 py-2 rounded-xl">
        {{ siteState.selectedSite()?.name }}
      </span>
      <button type="button" (click)="resetForm()"
        class="px-4 h-[46px] rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-300 transition-all cursor-pointer">
        รีเซ็ต
      </button>
      <button type="button" (click)="onCalculate()" [disabled]="isCalculating()"
        class="px-5 h-[46px] rounded-2xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center gap-2 cursor-pointer border-none disabled:opacity-60">
        <span class="material-icons text-[18px]">calculate</span>
        คำนวณ
      </button>
    </div>
  </div>

  <div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
    <!-- Form -->
    <div
      class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 p-6 md:p-8 space-y-5">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">tune</span>
        พารามิเตอร์จำลอง
      </h3>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Site ID</label>
          <input type="text" [ngModel]="selectedSiteId" disabled
            class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-bold opacity-70">
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Company ID</label>
          <input type="text" [ngModel]="companyId" disabled
            class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-bold opacity-70">
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            วันเข้า <span class="text-rose-500">*</span>
          </label>
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none z-10">event</span>
            <input type="text" [matDatepicker]="entryPicker" [(ngModel)]="entryDate"
              placeholder="dd/mm/yyyy" readonly (click)="entryPicker.open()"
              class="w-full h-[46px] pl-10 pr-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <mat-datepicker #entryPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
          </div>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            เวลาเข้า <span class="text-rose-500">*</span>
          </label>
          <input type="time" [(ngModel)]="entryTime"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            วันออก <span class="text-rose-500">*</span>
          </label>
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none z-10">event</span>
            <input type="text" [matDatepicker]="exitPicker" [(ngModel)]="exitDate"
              placeholder="dd/mm/yyyy" readonly (click)="exitPicker.open()"
              class="w-full h-[46px] pl-10 pr-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <mat-datepicker #exitPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
          </div>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            เวลาออก <span class="text-rose-500">*</span>
          </label>
          <input type="time" [(ngModel)]="exitTime"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
        </div>
      </div>

      <!-- Vehicle type -->
      <div class="relative">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทรถ</label>
        <input type="text" [(ngModel)]="vehicleTypeSearchText"
          (focus)="openDd('vehicleType')" (blur)="closeDropdowns()"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200"
          placeholder="เลือกประเภทรถ">
        <div *ngIf="openDropdown === 'vehicleType'"
          (mousedown)="$event.preventDefault()"
          class="absolute z-30 mt-1 w-full max-h-48 overflow-y-auto custom-scrollbar rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl">
          <button type="button" *ngFor="let opt of filteredVehicleTypes" (click)="selectVehicleType(opt)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium hover:bg-amber-50 dark:hover:bg-slate-700 border-none bg-transparent cursor-pointer">
            {{ opt.label }}
          </button>
        </div>
      </div>

      <!-- Card type -->
      <div class="relative">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทบัตร</label>
        <input type="text" [(ngModel)]="cardTypeSearchText"
          (focus)="openDd('cardType')" (blur)="closeDropdowns()"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200"
          placeholder="เลือกประเภทบัตร">
        <div *ngIf="openDropdown === 'cardType'"
          (mousedown)="$event.preventDefault()"
          class="absolute z-30 mt-1 w-full max-h-48 overflow-y-auto custom-scrollbar rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl">
          <button type="button" *ngFor="let opt of filteredCardTypes" (click)="selectCardType(opt)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium hover:bg-amber-50 dark:hover:bg-slate-700 border-none bg-transparent cursor-pointer">
            {{ opt.label }}
          </button>
        </div>
        <p class="text-[11px] text-slate-400 mt-1">cardType 3 หรือ 4 = member</p>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รหัสบัตร (Card Code)</label>
        <input type="text" [(ngModel)]="cardCode" placeholder="จำเป็นเมื่อเป็น member เพื่อ resolve stamp"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
      </div>

      <!-- Gate -->
      <div class="relative">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประตูเข้า (Entry Gate)</label>
        <input type="text" [(ngModel)]="gateSearchText"
          (focus)="openDd('gate')" (blur)="closeDropdowns()"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200"
          placeholder="ค้นหาประตู...">
        <div *ngIf="openDropdown === 'gate'"
          (mousedown)="$event.preventDefault()"
          class="absolute z-30 mt-1 w-full max-h-56 overflow-y-auto custom-scrollbar rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl">
          <button type="button" *ngFor="let g of filteredGates" (click)="selectGate(g)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium hover:bg-amber-50 dark:hover:bg-slate-700 border-none bg-transparent cursor-pointer">
            {{ g.name }} <span class="text-slate-400">#{{ g.id }}</span>
          </button>
          <p *ngIf="filteredGates.length === 0" class="px-4 py-3 text-xs text-slate-400">ไม่พบประตูในลานนี้</p>
        </div>
        <p class="text-[11px] text-slate-400 mt-1">ใช้หา default rate เมื่อไม่ระบุ DefaultRateId</p>
      </div>

      <!-- Stamp rate -->
      <div class="relative">
        <div class="flex items-center justify-between mb-2">
          <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">Stamp Rate ID</label>
          <button type="button" *ngIf="stampRateId" (click)="clearStampRate()"
            class="text-[11px] font-bold text-amber-600 border-none bg-transparent cursor-pointer">ล้าง</button>
        </div>
        <input type="text" [(ngModel)]="stampRateSearchText"
          (focus)="openDd('stampRate')" (blur)="closeDropdowns()"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200"
          placeholder="เลือกหรือเว้นว่างให้ระบบ resolve">
        <div *ngIf="openDropdown === 'stampRate'"
          (mousedown)="$event.preventDefault()"
          class="absolute z-30 mt-1 w-full max-h-56 overflow-y-auto custom-scrollbar rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl">
          <button type="button" *ngFor="let r of filteredStampRates" (click)="selectStampRate(r)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium hover:bg-amber-50 dark:hover:bg-slate-700 border-none bg-transparent cursor-pointer">
            <span class="font-mono font-bold">{{ r.mainRateId }}</span>
            <span *ngIf="r.name" class="text-slate-400"> — {{ r.name }}</span>
          </button>
        </div>
      </div>

      <!-- Default rate -->
      <div class="relative">
        <div class="flex items-center justify-between mb-2">
          <label class="text-xs font-bold text-slate-400 uppercase tracking-wider">Default Rate ID</label>
          <button type="button" *ngIf="defaultRateId" (click)="clearDefaultRate()"
            class="text-[11px] font-bold text-amber-600 border-none bg-transparent cursor-pointer">ล้าง</button>
        </div>
        <input type="text" [(ngModel)]="defaultRateSearchText"
          (focus)="openDd('defaultRate')" (blur)="closeDropdowns()"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200"
          placeholder="เลือกหรือเว้นว่างให้ระบบ resolve จาก gate">
        <div *ngIf="openDropdown === 'defaultRate'"
          (mousedown)="$event.preventDefault()"
          class="absolute z-30 mt-1 w-full max-h-56 overflow-y-auto custom-scrollbar rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl">
          <button type="button" *ngFor="let r of filteredDefaultRates" (click)="selectDefaultRate(r)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium hover:bg-amber-50 dark:hover:bg-slate-700 border-none bg-transparent cursor-pointer">
            <span class="font-mono font-bold">{{ r.mainRateId }}</span>
            <span *ngIf="r.name" class="text-slate-400"> — {{ r.name }}</span>
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Coupon free (นาที)</label>
          <input type="number" min="0" [(ngModel)]="couponFreeMinutes"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Paid Parking</label>
          <input type="number" min="0" step="0.01" [(ngModel)]="paidParking"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Paid Penalty</label>
          <input type="number" min="0" step="0.01" [(ngModel)]="paidPenalty"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
        </div>
      </div>

      <div class="flex flex-wrap gap-6 pt-1">
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" [(ngModel)]="isReprint"
            class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-200 cursor-pointer">
          <span class="text-sm font-semibold">Is Reprint</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" [(ngModel)]="isHoliday"
            class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-200 cursor-pointer">
          <span class="text-sm font-semibold">Is Holiday</span>
        </label>
      </div>
    </div>

    <!-- Result -->
    <div
      class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 p-6 md:p-8 space-y-5 min-h-[420px]">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">receipt_long</span>
        ผลการคำนวณ
      </h3>

      <div *ngIf="!result()" class="flex flex-col items-center justify-center py-16 text-slate-400 gap-3">
        <span class="material-icons text-5xl opacity-40">calculate</span>
        <p class="font-medium">กด «คำนวณ» เพื่อดูผล</p>
      </div>

      <ng-container *ngIf="result() as r">
        <div class="rounded-2xl px-4 py-3 text-sm font-semibold"
          [ngClass]="r.success
            ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300'
            : 'bg-rose-50 text-rose-700 dark:bg-rose-900/20 dark:text-rose-300'">
          {{ r.success ? 'สำเร็จ' : 'ไม่สำเร็จ' }} — {{ r.message || '—' }}
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">
          <div class="rounded-2xl bg-amber-50/80 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/40 p-4">
            <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Total Pay</p>
            <p class="text-2xl font-black text-amber-600 dark:text-amber-400 mt-1">{{ formatMoney(r.totalPay) }}</p>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700 p-4">
            <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Parking Fee</p>
            <p class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">{{ formatMoney(r.parkingFee) }}</p>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700 p-4">
            <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Company Fee</p>
            <p class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">{{ formatMoney(r.companyFee) }}</p>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700 p-4">
            <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Overnight</p>
            <p class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">{{ formatMoney(r.parkingOvernight) }}</p>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700 p-4">
            <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Penalty</p>
            <p class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">{{ formatMoney(r.penaltyFee) }}</p>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700 p-4">
            <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Discount</p>
            <p class="text-xl font-black text-slate-800 dark:text-slate-100 mt-1">{{ formatMoney(r.discount) }}</p>
          </div>
        </div>

        <div class="rounded-2xl border border-slate-100 dark:border-slate-700 divide-y divide-slate-50 dark:divide-slate-800 text-sm">
          <div class="flex justify-between gap-3 px-4 py-2.5">
            <span class="text-slate-400 font-medium">นาทีรวม / ลูกค้า / บริษัท</span>
            <span class="font-bold text-slate-700 dark:text-slate-200">{{ r.totalMin }} / {{ r.customerMin }} / {{ r.companyMin }}</span>
          </div>
          <div class="flex justify-between gap-3 px-4 py-2.5">
            <span class="text-slate-400 font-medium">Owner free / Company free</span>
            <span class="font-bold text-slate-700 dark:text-slate-200">{{ r.ownerFreeMin }} / {{ r.companyFreeMin }}</span>
          </div>
          <div class="flex justify-between gap-3 px-4 py-2.5">
            <span class="text-slate-400 font-medium">Stamp / Default Rate</span>
            <span class="font-mono font-bold text-slate-700 dark:text-slate-200">{{ r.stampRateId || '—' }} / {{ r.defaultRateId || '—' }}</span>
          </div>
          <div class="flex justify-between gap-3 px-4 py-2.5">
            <span class="text-slate-400 font-medium">เข้า / ออก</span>
            <span class="font-bold text-slate-700 dark:text-slate-200 text-right">
              {{ r.entryDate ? (r.entryDate | date:'dd/MM/yyyy HH:mm') : '—' }}
              →
              {{ r.exitDate ? (r.exitDate | date:'dd/MM/yyyy HH:mm') : '—' }}
            </span>
          </div>
          <div class="flex justify-between gap-3 px-4 py-2.5">
            <span class="text-slate-400 font-medium">Member / Reprint / Gate</span>
            <span class="font-bold text-slate-700 dark:text-slate-200">
              {{ r.isMemberCard ? 'Yes' : 'No' }} / {{ r.isReprint ? 'Yes' : 'No' }} / {{ r.entryGateId ?? '—' }}
            </span>
          </div>
          <div class="flex justify-between gap-3 px-4 py-2.5">
            <span class="text-slate-400 font-medium">Paid Parking / Penalty</span>
            <span class="font-bold text-slate-700 dark:text-slate-200">{{ formatMoney(r.paidParking) }} / {{ formatMoney(r.paidPenalty) }}</span>
          </div>
          <div class="flex justify-between gap-3 px-4 py-2.5" *ngIf="r.remarkTh || r.remarkEng">
            <span class="text-slate-400 font-medium">Remark</span>
            <span class="font-medium text-slate-700 dark:text-slate-200 text-right max-w-[60%]">{{ r.remarkTh || r.remarkEng }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading() || isCalculating()"></app-pss-loading>
